import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface AdSettings {
  adsenseClientId: string | null;
}

export function useAdSettings() {
  return useQuery({
    queryKey: ['ad-settings'],
    queryFn: async (): Promise<AdSettings> => {
      const { data, error } = await supabase
        .from('site_settings')
        .select('key, value')
        .eq('key', 'adsense_client_id')
        .maybeSingle();

      if (error) {
        console.error('Error fetching ad settings:', error);
        return { adsenseClientId: null };
      }

      return {
        adsenseClientId: data?.value || null,
      };
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}